import { GetEmpresasGestionadasAsesoriaByFiltersDtoProps } from "./DTOs/GetEmpresasGestionadasAsesoriaByFiltersDto"
import { GetInvitacionesAsesoriaDtoProps } from "./DTOs/GetInvitacionesAsesoriaDto"

export const GetEmpresasGestionadasAsesoriaByFiltersDtoAdapter = (
  empresa: GetEmpresasGestionadasAsesoriaByFiltersDtoProps
) => ({
  id: empresa.id,
  actividad: empresa?.actividad,
  email: empresa?.email,
  estadoInvitacion: empresa?.estadoInvitacion,
  nif: empresa?.nif,
  provincia: empresa?.provincia,
  razonSocial: empresa?.razonSocial,
})

export const empresaGestionadaAsesoriaInvitacionAdapter = (
  invitacion: GetInvitacionesAsesoriaDtoProps
) => ({
  id: invitacion.id,
  logo: {
    base64: invitacion.logo?.base64 ?? "",
    mediaType: invitacion.logo?.mediaType ?? "",
  },
  provinciaRegistroMercantil: invitacion.provinciaRegistroMercantil,
  razonSocial: invitacion.razonSocial,
})
